import ajax from './ajax'
const BASE_URL = '/api'

// 获取招生计划条件
export const findQueryPlan = () => ajax(BASE_URL + '/xgkData/condtion');

// 查询新的招生计划
export const queryPlanAll = (enrollmentPlan) => ajax(BASE_URL + '/xgkData/getZsjh', enrollmentPlan,'POST')

// 根据国标生成对比数据
export const createCompareData = (yxs) => ajax(BASE_URL + '/yxDdb', yxs, 'POST')

// 获取专家信息
export const getZjService=()=>ajax(BASE_URL+'/zj/getZjxx')

// 获取常见问题
export const getQuestions=()=>ajax(BASE_URL+'/cjwt/getCommonProblem')

// 文化生获取省市区
export const getShixian=(dqbm)=>ajax(BASE_URL+"/xzqh/shixian",{dqbm})

// 文化生获取学校
export const getSchools=(dqbm)=>ajax(BASE_URL+"/zxml/getShools",{dqbm})
